import { defineComponent as s, resolveComponent as t, openBlock as o, createElementBlock as m, createBlock as n, createCommentVNode as i, createVNode as p, withCtx as c, createTextVNode as d, toDisplayString as g } from "vue";
import u from "../VIcon/VIcon.js";
import { V as f } from "../../../VImage-b57fd9d1.js";
import V from "../VText/VText.js";
import { _ as h } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../utils/tailwindUnitsConverter.js";
const y = s({
  name: "VIconWithText",
  components: { VIcon: u, VText: V, VImage: f },
  props: {
    symbol: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    iconSize: {
      type: [String, Number],
      default: 13
    },
    iconViewBox: {
      type: String,
      default: "0 0 24 24"
    },
    iconHeight: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    labelSize: {
      type: String,
      validator(e) {
        return ["xs", "s", "m"].indexOf(e) !== -1;
      },
      default: "xs"
    },
    renderSingleLine: {
      type: Boolean,
      default: !0
    }
  }
}), S = { class: "tw-flex tw-items-center" };
function b(e, w, z, B, I, x) {
  const r = t("VIcon"), l = t("VImage"), a = t("VText");
  return o(), m("div", S, [
    e.symbol ? (o(), n(r, {
      key: 0,
      symbol: e.symbol,
      size: e.iconSize,
      class: "tw-mr-2",
      height: e.iconHeight,
      viewBox: e.iconViewBox
    }, null, 8, ["symbol", "size", "height", "viewBox"])) : i("", !0),
    e.url ? (o(), n(l, {
      key: 1,
      image: e.url,
      role: "presentation",
      class: "tw-mr-2",
      height: e.iconHeight
    }, null, 8, ["image", "height"])) : i("", !0),
    p(a, {
      size: e.labelSize,
      renderSingleLine: e.renderSingleLine
    }, {
      default: c(() => [
        d(g(e.label), 1)
      ]),
      _: 1
    }, 8, ["size", "renderSingleLine"])
  ]);
}
const N = /* @__PURE__ */ h(y, [["render", b]]);
export {
  N as default
};
